
<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-card>
            <!--v-toolbar dense color="grey lighten-4">
               <v-toolbar-title>Messages</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn icon ripple @click="newMessageDialog = true">
                  <v-icon>add</v-icon>
               </v-btn>
            </v-toolbar-->

            <v-card-text class="padded">
               <v-btn @click="newMessage"
                     fab small color="yellow"
                     top right absolute>
                  <v-icon>add</v-icon>
               </v-btn>
               <div v-for="(message, index) in messages">
               
                  <div :class="{ 'message-from-me': user.id === message.author, 'message-from-them': user.id !== message.author }">
                     <div class="message-author">{{ message.author_fullname }}</div>
                     <div class="message-date">{{ formatDate(message.date) }}</div>
                     <div class="message-text"> {{ message.text }}</div>
                  </div>

                  <!-- mandatory -->
                  <div class="clear"></div>
               </div>
            </v-card-text>

            <v-card-text v-if="messages.length === 0" style="height: 100px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>

         </v-card>
      </v-flex>

      <v-dialog v-model="newMessageDialog" persistent max-width="800">
         <v-card>
            <v-card-title class="headline grey lighten-2">Nouveau message</v-card-title>

            <v-form v-model="valid">
               <v-container grid-list-md>
                  <v-layout wrap>
                     <v-flex xs12>
                        <v-autocomplete
                           label="Destinataires"
                           multiple
                           chips
                           cache-items
                           :items="possible_targets"
                           item-text="fullname"
                           item-value="id"
                           v-model="messageToSend.visible_by"
                           @input="$v.messageToSend.$touch(); $v.messageToSend.$touch()"
                           blur="$v.messageToSend.$touch(); $v.messageToSend.$touch()"
                           :error-messages="targetsErrors"
                        ></v-autocomplete>
                     </v-flex>
                     <v-flex xs12>
                        <v-textarea
                           label="Texte"
                           required
                           v-model="messageToSend.text"
                           @input="$v.messageToSend.$touch(); $v.messageToSend.$touch(); onChanged()"
                           :error-messages="textErrors"
                        ></v-textarea>
                     </v-flex>
                  </v-layout>
               </v-container>
            </v-form>

            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn :disabled="!formValidAndDirty" color="brown darken-2" flat @click.native="newMessageDialog = false; sendMessage(messageToSend)">Envoyer</v-btn>
               <v-btn color="brown darken-2" flat @click.native="newMessageDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

   </v-layout>
</template>


<script>
   import formatDate from "@/utilities/formatDate.js"
   import { required } from 'vuelidate/lib/validators'
   import _ from 'lodash'

   export default {

      props: {
         userId: Number,
      },

      mounted: function() {
         let self = this
         // fetch user and her coaches
         this.$store.dispatch('GET_USER', this.userId)
         .then(function(user) {
            user.coaches.forEach(function(coachId) {
               self.$store.dispatch('GET_USER', coachId)
            })
         })
         // fetch user messages
         this.$store.dispatch('GET_USER_MESSAGES', this.userId)
      },

      data () {
         return {
            selectedMessageId: null,
            newMessageDialog: false,
            messageToSend: {
               user: null,
               text: null,
               author: null,
               visible_by: [],
               read_by: [],
            },
            valid: false,
         }
      },

      computed: {
         user () {
            return this.$store.state.users[this.userId]
         },
         coaches () {
            return this.user.coaches.map(userId => this.$store.state.users[userId])
         },
         possible_targets () {
            let targets = []
            if (this.$store.state.loggedUserId !== this.userId) {
               targets.push(this.user)
            }
            let self = this
            this.user.coaches.forEach(function(coachId) {
               if (coachId !== self.$store.state.loggedUserId) {
                  let coach = self.$store.state.users[coachId]
                  targets.push(coach)
               }
            })
            return targets
         },
         messages () {
            if (this.$store.state.user2messageList.hasOwnProperty(this.userId)) {
               let result = []
               let self = this
               this.$store.state.user2messageList[this.userId].forEach(async function(messageId) {
                  let message = self.$store.state.messages[messageId]
                  // logged user must be the author of the message, or in its 'visible_by' list
                  if (message.author === self.$store.state.loggedUserId || message.visible_by.indexOf(self.$store.state.loggedUserId) !== -1) {
                     result.push(message)
                     // mark it as read
                     if (message.read_by.indexOf(self.$store.state.loggedUserId) === -1) {
                        let messageCopy = _.cloneDeep(message)
                        messageCopy.read_by.push(self.$store.state.loggedUserId)
                        await self.$store.dispatch('PUT_USER_MESSAGE', messageCopy)
                        self.$store.dispatch('COUNT_UNREAD_MESSAGES', self.userId)
                     }
                  }
               })
               return result
            } else {
               return []
            }
         },
         formValid () {
            if (this.$v.messageToSend.text.$error) return false
            if (this.$v.messageToSend.visible_by.$error) return false
            return true
         },
         formDirty () {
            return this.$v.messageToSend.$dirty
         },
         formValidAndDirty () {
            return this.formValid && this.formDirty
         },
         targetsErrors () {
            const errors = []
            if (!this.$v.messageToSend.visible_by.$dirty) return errors
            !this.$v.messageToSend.visible_by.required && errors.push("Un destinataire au moins est requis")
            return errors
         },
         textErrors () {
            const errors = []
            if (!this.$v.messageToSend.text.$dirty) return errors
            !this.$v.messageToSend.text.required && errors.push("Le texte est obligatoire")
            return errors
         },
      },

      methods: {
         authorName (message) {
            let author = this.$store.state.users[message.author]
            return author.fullname
         },
         sendMessage (message) {
            try {
               this.$store.dispatch('POST_USER_MESSAGE', message)
            } catch(e) {
               console.log(e.response)
            }
         },
         newMessage () {
            this.messageToSend = {
               user: this.userId,
               author: this.$store.state.loggedUserId,
               visible_by: this.possible_targets.map(user => user.id),
               read_by: [this.$store.state.loggedUserId],
               text: null,
            },
            this.newMessageDialog = true
         },
         onChanged () {
            this.dirty = true
         },
         formatDate (date) {
            return formatDate(date)
         },
      },

      // vuelidate validators
      validations: {
         messageToSend: {
            visible_by: {
               required,
            },
            text: {
               required,
            },
         }
      },

   };
</script>

<style scoped lang="scss" type="text/scss">

.padded {
	padding: 20px;
}

.message-text {
   padding-left: 18px;
   padding-right: 18px;
   padding-top: 10px;
   padding-bottom: 10px;
   margin-top: 3px;
   margin-bottom: 15px;
   border-radius: 18px;
}

.message-author {
   color: #444444;
   font-size: 0.9em;
}

.message-date {
   color: #888888;
   font-size: 0.8em;
}

.message-from-me {
   position: relative;
   float: right;

   .message-text {
      color: white; 
      background: #0B93F6;
   }
}
.message-from-them {
   position: relative;
   float: left;

   .message-text {
      color: black;
      background: #E5E5EA;
   }
}

</style>



// WEBPACK FOOTER //
// Messages.vue?d6ae240e